import { type ComponentRef, Directive, type Type, effect, inject, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import type { PopoverPlacement } from '@frontendlib/components/features/popover/types/placement';
import type { PopoverTrigger } from '@frontendlib/components/features/popover/types/trigger';
import { FoldersListContextMenuComponent } from './folders-list-context-menu/folders-list-context-menu.component';
import { BoardsStore } from '../../services/boards.store';

/**
 * Opens the Folders list's sorting & filters menu from the Folders row's "⋯" (`app-context-menu-state-indicator`, as in
 * Slides), the same way `appBoardsListContextMenu` does for the board list.
 */
@Directive({
  selector: '[appBoardsFoldersListContextMenu]',
  standalone: true,
})
export class BoardsFoldersListContextMenuDirective extends ContextMenuDirective {
  @Input() public override stchPopoverTrigger: PopoverTrigger = 'click';
  @Input() public override stchPopoverPlacement: PopoverPlacement = 'bottomLeft';

  private readonly store = inject(BoardsStore);

  private readonly syncIndicator = effect(() => {
    this.isDefaultStateObservable?.next(this.store.isDefaultFolderOptions());
  });

  /** The indicator's reset cross pushes `true`; its initial `null` and the store's own echo above are no-ops. */
  private readonly resetFromIndicator = this.isDefaultStateObservable?.pipe(takeUntilDestroyed()).subscribe((isDefault) => {
    if (isDefault && !this.store.isDefaultFolderOptions()) {
      this.store.resetFolderOptions();
    }
  });

  protected registerComponent(): Type<FoldersListContextMenuComponent> {
    return FoldersListContextMenuComponent;
  }

  protected registerInstance(componentRef: ComponentRef<FoldersListContextMenuComponent>): void {
    componentRef.instance.store = this.store;
  }
}
